var _path, _path2, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNewSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22.53 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.170018 8.3245C0.721484 4.97378 2.58143 1.97937 5.34069 0L6.94995 2.24332C4.78565 3.79589 3.32675 6.14463 2.8942 8.77285C2.46164 11.4011 3.09086 14.0935 4.64343 16.2578C6.196 18.4221 8.54474 19.881 11.173 20.3135C13.8003 20.7459 16.5275 20.1512 18.6915 18.5998L18.6937 18.5981L22.5349 23.5916L20.4862 25L18.2061 22.0123C15.8886 23.0907 13.2828 23.4587 10.7246 23.0377C7.3739 22.4862 4.37948 20.6263 2.40011 17.867C0.420741 15.1078 -0.381447 11.6752 0.170018 8.3245Z",
    fill: "#081538"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0135 16.0588C19.9383 14.3662 20.6848 11.547 20.4991 9.66095C20.3135 7.77489 19.4348 6.02328 18.0321 4.74291C16.6294 3.46253 14.8017 2.74377 12.9003 2.72484C10.999 2.7059 9.15821 3.38812 7.732 4.64032C6.30579 5.89253 5.3948 7.62631 5.1742 9.50832C4.95359 11.3903 5.43894 13.2877 6.53693 14.8356C7.63492 16.3835 9.26803 17.4727 11.1223 17.8938C13.7858 18.4986 16.0491 17.4981 17.4463 16.5156C16.0954 15.5334 14.2698 15.6109 12.6018 15.5261C12.3011 15.5109 11.9972 15.4683 11.6909 15.3988C10.4544 15.118 9.36543 14.3917 8.63326 13.3595C7.90109 12.3273 7.57744 11.0621 7.72454 9.8071C7.87165 8.55212 8.47913 7.39597 9.43017 6.56096C10.3812 5.72595 11.6087 5.27103 12.8766 5.28365C14.1445 5.29628 15.3633 5.77557 16.2986 6.62937C17.234 7.48317 17.8199 8.6512 17.9437 9.90888C17.967 10.313 17.9627 10.7025 17.9169 11.0847C17.7165 12.7555 17.3066 14.5317 18.0135 16.0588Z",
    fill: "#717BBC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.807,
    cy: 10.4096,
    rx: 2.56077,
    ry: 2.56077,
    transform: "rotate(-38.8432 12.807 10.4096)",
    fill: "#717BBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNewSmall);
export default __webpack_public_path__ + "static/media/logo_new_small.577145c3227f3a616a49d8c1fbd0f8a3.svg";
export { ForwardRef as ReactComponent };